import React from 'react';
import { useApi } from '../hooks.js';
import PropTypes from 'prop-types';
export default function TablistOverflow(deps, props) {
  var _deps = deps(useApi()),
    tablistOverflowPropsManager = _deps.tablistOverflowPropsManager;
  return /*#__PURE__*/React.createElement("div", tablistOverflowPropsManager(), props.children);
}